import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const create = gql`
  mutation CreateCardMutation($input: CreateCard!) {
    createCard(input: $input) {
      ...Card
    }
  }

  ${Fragments.card.card}
`;

export const update = gql`
  mutation UpdateCardMutation($input: UpdateCard!) {
    updateCard(input: $input) {
      ...Card
    }
  }

  ${Fragments.card.card}
`;

export const remove = gql`
  mutation RemoveCardMutation($input: DeleteCard!) {
    deleteCard(input: $input)
  }
`;
export const markCardsViewed = gql`
  mutation MarkCardsViewedMutation($channelId: Int!) {
    createClientEvent(input: { channelId: $channelId, event: CARDS_VIEWED }) {
      id
    }
  }
`;

export const createCardFieldStringTag = gql`
  mutation CreateCardFieldStringTagMutation($input: CreateCardFieldStringTag!) {
    tag: createCardFieldStringTag(input: $input) {
      ...TagOption
    }
  }

  ${Fragments.card.tag}
`;

export const updateCardFieldStringTag = gql`
  mutation UpdateCardFieldStringTagMutation($input: UpdateCardFieldStringTag!) {
    tag: updateCardFieldStringTag(input: $input) {
      ...TagOption
    }
  }

  ${Fragments.card.tag}
`;

export const archiveCardFieldStringTag = gql`
  mutation ArchiveCardFieldStringTagMutation($input: ArchiveCardFieldStringTag!) {
    tag: archiveCardFieldStringTag(input: $input) {
      ...TagOption
    }
  }

  ${Fragments.card.tag}
`;

export const createFragmentTemplate = gql`
  mutation CreateCardFragmentTemplateMutation($input: CreateCardFragmentTemplate!) {
    createCardFragmentTemplate(input: $input) {
      ...FragmentTemplate
    }
  }

  ${Fragments.card.fragmentTemplate}
`;

export const deleteFragmentTemplate = gql`
  mutation DeleteFragmentTemplateMutation($id: UUID!) {
    deleteCardFragmentTemplate(id: $id)
  }
`;

export const createBatchCards = gql`
  mutation CreateBatchCardsMutation($input: CreateCards!) {
    createCards(input: $input) {
      ...Card
    }
  }

  ${Fragments.card.card}
`;

export const deleteBatchCards = gql`
  mutation DeleteBatchCardsMutation($input: DeleteCards!) {
    deleteCards(input: $input)
  }
`;

export const createCardExport = gql`
  mutation CreateCardExportMutation($input: CreateCardExport!) {
    createCardExport(input: $input) {
      url
    }
  }
`;
